import React, { FunctionComponent } from 'react';
import { NavLink as ReactRouterNavLink } from "react-router-dom";
import {ClassBuilder} from 'b302-frontend-library';

import HanLogo from "../../assets/icons/han_logo_header.svg";
import {useAuth} from '../../contexts/AuthContext';

interface Props {
    children: any;
    className?: string;
}

const NavBar: FunctionComponent<Props> = ({ children, className }) => {
    const { user, isAuthenticated } = useAuth();

    const getClassName = () => (
        ClassBuilder.createClass('navbar')
            .addIf(className, className)
            .build()
    );

    return (
        <nav className={getClassName()}>
            <div className={'navbar__content'}>
                <div className="navbar__left">
                    <ReactRouterNavLink end={true} to={'/'}>
                        <div className={"navbar__container"}>
                            <img className="navbar__container__logo" src={HanLogo} alt="Han logo"/>
                        </div>
                    </ReactRouterNavLink>

                    { isAuthenticated &&
                        <span className={'navbar__login-info'}>
                            <span className={'navbar__user'}>User: { user?.name }</span>
                        </span>
                    }
                </div>

                <div className="navbar__right">
                    { children }
                </div>
            </div>
        </nav>
    );
};
 
export default NavBar;
